const IS_BACKEND_AS_PER_FRONTEND =
  import.meta.env.VITE_IS_BACKEND_AS_PER_FRONTEND === "true";
export let BASE_API_URL = import.meta.env.VITE_BASE_API_URL;

if (IS_BACKEND_AS_PER_FRONTEND) {
  const frontendHost = window.location.hostname;
  if (frontendHost === "cpgramsaichatbot.com") {
    BASE_API_URL = "https://chatbot.cpgramsaichatbot.com/";
  } else if (frontendHost.includes("azurewebsites.net")) {
    BASE_API_URL = "https://backend.aibott.org/cp_backend/";
    // BASE_API_URL = "https://chatbot.cpgramsaichatbot.com/";
  } else if (frontendHost === "localhost" || frontendHost === "127.0.0.1") {
    // BASE_API_URL = "https://backend.aibott.org/cp_backend/";
    BASE_API_URL = "https://chatbot.cpgramsaichatbot.com/";
  }
}

export const API_VERSION = import.meta.env.VITE_API_VERSION;
export const BASE_URL = `${BASE_API_URL}${API_VERSION}`;
export const NIC_API_URL = import.meta.env.VITE_NIC_API_URL || "http://164.100.230.114/CpgramsReformsWebApiTest/api";

export const API_ENDPOINTS = {
  languageDetection: `${BASE_URL}input_query_lang`, // TLD 
  generateContent: `${BASE_URL}jb_categorize_grievance`, // Main bot api
  transliterate: `${BASE_URL}transliterate`, // translitration
  generateAudio: `${BASE_API_URL}process_audio`, // unused
  speech2text: `${BASE_API_URL}speech2text`, // used as fallback in voice input
  liveDepartments: `${BASE_URL}live_departments`, // unused
  audioLanguageDetection: `${BASE_API_URL}audio_lang_detection`, // ALD
  botResponseStatus: `${BASE_URL}identified_properties`, // unused
  logger_url: `${BASE_API_URL}frontend_logger`, // frontend logger
  getAdditionalDropdownValueList: `${BASE_API_URL}get_additional_dropdown_value_list`, // NIC API for field form data
  searchAdditionalFields: `${BASE_API_URL}search_additional_fields`, // NIC API for searching additional fields
  getUserProfileNIC: `${BASE_URL}get_userid_nic`, // NIC Auth API
  registerGrievance: `${BASE_URL}lodge_grievance_reformed`, // Reformed grievance registration
  frontend_timing_logger: `${BASE_API_URL}frontend_timing_logger`, // frontend timing logger
  registerStateGrievance: `${BASE_URL}lodge_grievance_nonreformed`, // Non reformed grievance registration
  progressUpdateOnGrievance: `${BASE_URL}progress`, // Polling status
};

// /v1/progress
// curl -X 'GET' \
//   'http://localhost:1890/v1/progress' \
//   -H 'accept: application/json' \
//   -H 'x-source: fec4bfdb_2d06_4d79_bd1b_82a486a54a68'


export const NIC_APIS = {
  getAdditionalFields: `${NIC_API_URL}/GetAdditionalDropdownValueList`,
};